// NCCA Refund Consent — shows the Digital Course & Refund Policy disclaimer and a
// REQUIRED consent checkbox above the Checkout button (cart page + cart drawer).
// Blocks checkout (and accelerated buttons) until acknowledged, and records the
// acknowledgment as a cart attribute so it appears on the order.
(function () {
  'use strict';

  var FLAG = 'data-ncca-consent';
  var POLICY = 'This purchase provides access to proprietary digital educational content. Due to the immediate availability and nonreturnable nature of digital course materials, all sales are final once login credentials, downloadable materials, electronic files, course links, or platform access have been issued. Refunds will not be provided because a student changes examination plans, decides not to take the examination, does not use the course, dislikes the presentation format, fails the examination, or purchases another provider’s program. This policy does not limit any remedy available where NC Contractor Academy fails to provide the purchased product or materially misrepresents the program.';
  var CONSENT = 'I understand that I am purchasing digital educational materials and consent to immediate delivery. I acknowledge that the purchase becomes nonrefundable once access or materials are issued.';

  // PRINTED BOOKS (Oct 2026). The exam book bundles are the first items that ship. The cart is read
  // from /cart.js (each item carries requires_shipping) and the wording follows what is in it:
  //   digital only -> exactly the text above, unchanged
  //   books only   -> the book terms
  //   both         -> both, and one checkbox that covers both
  // Book terms set by Adam, 2 Oct 2026: free shipping, final sale, damaged/wrong books replaced within 7 days.
  var BOOK_POLICY = 'Printed exam books ship free to the address you enter at checkout and are delivered in 5 to 7 business days. Each set is tabbed and highlighted for you, so book bundles are final sale. If a book arrives damaged or is not the book listed, tell us within 7 days of delivery and we will replace it at no cost.';
  var BOOK_CONSENT = 'I understand that book bundles are final sale and are delivered in 5 to 7 business days.';
  var mode = 'digital';          // 'digital' | 'books' | 'both'
  var lastFetch = 0;
  function fetchMode() {
    var now = Date.now();
    if (now - lastFetch < 1000) return;
    lastFetch = now;
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ship = false, dig = false;
          (cart.items || []).forEach(function (it) { if (it.requires_shipping) ship = true; else dig = true; });
          var m = ship && dig ? 'both' : (ship ? 'books' : 'digital');
          if (m !== mode) { mode = m; refreshBlocks(); }
        })
        .catch(function () {});
    } catch (e) {}
  }
  function policyHtml() {
    var d = '<strong>Digital Course and Refund Policy:</strong> ' + POLICY;
    var b = '<strong>Printed Exam Books:</strong> ' + BOOK_POLICY;
    return mode === 'books' ? b : (mode === 'both' ? d + '<br><br>' + b : d);
  }
  function consentText() {
    return mode === 'books' ? BOOK_CONSENT : (mode === 'both' ? CONSENT + ' ' + BOOK_CONSENT : CONSENT);
  }
  function refreshBlocks() {
    var blocks = document.querySelectorAll('.ncca-consent');
    for (var i = 0; i < blocks.length; i++) {
      blocks[i].querySelector('.ncca-consent__policy').innerHTML = policyHtml();
      blocks[i].querySelector('.ncca-consent__text').textContent = consentText();
      blocks[i].querySelector('.ncca-consent__cb').checked = false;   // new terms need a new tick
    }
    recorded = false;
    processGate();
  }
  var SCOPE_SEL = '.cart-summary, cart-drawer, .cart-drawer, .drawer, .cart-totals, form[action*="/cart"], [class*="cart-summary"]';
  var BTN_SEL = 'button[name="checkout"], .cart__checkout-button';

  function injectStyle() {
    if (document.getElementById('ncca-consent-style')) return;
    var s = document.createElement('style');
    s.id = 'ncca-consent-style';
    s.textContent =
      '.ncca-consent{border:1.5px solid #d9d2ea;background:#faf9fd;border-radius:12px;padding:13px 15px;margin:0 0 14px;font-size:.82rem;line-height:1.45;color:#3a3450;text-align:left;width:100%;box-sizing:border-box}' +
      '.ncca-consent__policy{max-height:120px;overflow:auto;margin-bottom:11px;padding-right:4px;color:#514a66}' +
      '.ncca-consent__policy strong{color:#2A1B45}' +
      '.ncca-consent__check{display:flex;gap:10px;align-items:flex-start;cursor:pointer;font-weight:600;color:#2A1B45}' +
      '.ncca-consent__cb{margin-top:2px;width:19px;height:19px;flex:none;accent-color:#5C4287;cursor:pointer}' +
      '.ncca-consent__req{color:#b4231d;font-weight:700}';
    document.head.appendChild(s);
  }

  function buildBlock() {
    var b = document.createElement('div');
    b.className = 'ncca-consent';
    b.setAttribute(FLAG, 'true');
    b.innerHTML =
      '<div class="ncca-consent__policy">' + policyHtml() + '</div>' +
      '<label class="ncca-consent__check"><input type="checkbox" class="ncca-consent__cb"><span><span class="ncca-consent__text"></span> <span class="ncca-consent__req">*</span></span></label>';
    b.querySelector('.ncca-consent__text').textContent = consentText();
    return b;
  }

  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }

  var recorded = false;
  function record() {
    if (recorded) return; recorded = true;
    try {
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Refund Policy Acknowledged': 'Yes (' + mode + ') — ' + new Date().toISOString() } })
      });
    } catch (e) { recorded = false; }
  }

  function processGate() {
    var blocks = document.querySelectorAll('.ncca-consent');
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var cb = block.querySelector('.ncca-consent__cb');
      var ok = cb && cb.checked;
      var scope = block.closest(SCOPE_SEL) || block.parentNode;
      var btns = scope.querySelectorAll(BTN_SEL);
      for (var j = 0; j < btns.length; j++) { btns[j].disabled = !ok; btns[j].style.opacity = ok ? '' : '0.5'; btns[j].setAttribute('aria-disabled', String(!ok)); }
      var acc = scope.querySelector('.additional-checkout-buttons, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="dynamic-checkout"]');
      if (acc) { acc.style.pointerEvents = ok ? '' : 'none'; acc.style.opacity = ok ? '' : '0.4'; }
      if (ok) record();
    }
  }

  function process() {
    fetchMode();
    var btns = document.querySelectorAll(BTN_SEL);
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (!visible(btn)) continue;
      var scope = btn.closest(SCOPE_SEL) || btn.parentNode;
      if (scope.querySelector('[' + FLAG + ']')) continue;
      injectStyle();
      var block = buildBlock();
      btn.parentNode.insertBefore(block, btn);
      block.querySelector('.ncca-consent__cb').addEventListener('change', processGate);
    }
    processGate();
  }

  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; requestAnimationFrame(function () { scheduled = false; process(); }); }

  function start() {
    process();
    try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
